module.exports = __webpack_public_path__ + "img/s_whitewhiteT-logo.800eb84.png";